export default {
    address: require('./address').default,
    country: require('./country').default,
    quote: require('./quote').default,
    organisation: require('./organisation').default,
    parcel: require('./parcel').default,
    category: require('./category').default,
    order: require('./order').default,
    transit: require('./transit').default,
    locale: require('./locale').default,
}
